class UserBaseModel {
    constructor(name, email) {
        this.name = name;
        this.email = email;
    }
}

export default UserBaseModel;
